import { useMutation } from '@tanstack/react-query';
import { useNavigate, useRouter } from '@tanstack/react-router';
import { ok } from 'neverthrow';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { useAuth } from '@/components/features/auth-provider';
import { loginMutation } from '@/mutations/auth/loginMutation';

export const useLogin = () => {
  const { persistLogin } = useAuth();
  const router = useRouter();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { mutateAsync: loginAsync } = useMutation(loginMutation());

  return async (
    values: { email: string; password: string },
    search: {
      invitationCode?: string;
      organizationId?: string;
      redirect?: string;
    }
  ) => {
    const response = await loginAsync({
      email: values.email,
      password: values.password,
    });

    if (response.isErr()) {
      return response;
    }

    persistLogin(
      response.value.user,
      response.value.accessToken,
      response.value.refreshToken ?? ''
    );

    router.invalidate();

    const isVerified = response.value.user.verified;

    if (!isVerified) {
      navigate({ to: '/verify', search });
    } else {
      navigate({ to: '/dashboard', search });
      toast.success(t('auth.login.form.toast.success'));
    }

    return ok();
  };
};
